<template>
  <div class="d-flex justify-content-between align-items-center">
    <h5 class="mb-0">{{ title }}</h5>
    <div class="d-flex gap-2">
      <b-button 
        v-if="isEditing" 
        key="save" 
        size="sm" 
        variant="success" 
        :disabled="disabled"
        @click="$emit('save')"
      >Save</b-button>
      <b-button 
        v-if="!isEditing" 
        key="edit" 
        size="sm" 
        variant="sharp-primary"
        :disabled="disabled" 
        @click="$emit('edit')"
      ><b-icon icon="pencil" class="mr-2"></b-icon>Edit</b-button>
      <b-button 
        v-else 
        key="cancel" 
        size="sm" 
        variant="secondary" 
        :disabled="disabled"
        @click="$emit('cancel')"
      >Cancel</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TagFieldsHeader',
    props: {
      title: { type: String, default: 'Taggings' },
      isEditing: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
    },
  };
</script>
